import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_square_event.js";
//#region src/bite_log_square_event_helper.ts
var bite_log_square_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "authorization-success";
		case 2: return "authorization-error";
		case 3: return "reader-settings-success";
		case 4: return "reader-settings-error";
		case 5: return "checkout-error-deprecated";
		case 6: return "reader-disconnected";
		case 7: return "checkout-cancelled";
		case 8: return "checkout-err-not-authorized";
		case 9: return "checkout-err-usage";
		case 10: return "checkout-timeout";
		case 13: return "checkout-no-network";
		case 14: return "checkout-checkout-location-services-disabled";
		case 11: return "pairing-success";
		case 12: return "pairing-error";
	}
}
//#endregion
export { bite_log_square_event_helper_exports, name };

//# sourceMappingURL=bite_log_square_event_helper.js.map